import { render, staticRenderFns } from "./JobItemGhost.vue?vue&type=template&id=f7fdd26a&scoped=true"
import script from "./JobItemGhost.vue?vue&type=script&lang=js"
export * from "./JobItemGhost.vue?vue&type=script&lang=js"
import style0 from "./JobItemGhost.vue?vue&type=style&index=0&id=f7fdd26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fdd26a",
  null
  
)

export default component.exports